module.exports = __webpack_public_path__ + "static/media/mudanca-busca-ativa.230d1deb.svg";